import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrearFacturaManualComponent } from './pages/crear-factura-manual/crear-factura-manual.component';

const routes: Routes = [
    { path: 'crear_factura_manual', component: CrearFacturaManualComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacturacionRoutingModule { }
